module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-dialog', {
    attrs: {
      "custom-class": "ushk-remark",
      "size": "large"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.data.type === 'image-text') ? _c('div', {
    staticClass: "ushk-remark__ctn"
  }, [_c('div', {
    staticClass: "ushk-remark__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.pic,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.data.content) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.data.type === 'content') ? [_c('div', {
    staticClass: "ushk-remark-content"
  }, [_c('i'), _vm._v(" "), _c('h3', {
    staticClass: "ushk-remark__title"
  }, [_vm._v("\n        " + _vm._s(_vm.data.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ushk-remark__text"
  }, [_vm._v("\n        " + _vm._s(_vm.data.content) + "\n      ")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "ushk-remark-content__info"
  }, [_vm._v("美港电讯注")])] : _vm._e(), _vm._v(" "), (_vm.data.type === 'video') ? _c('div', {
    staticClass: "ushk-remark-video"
  }, [_c('div', {
    staticClass: "ushk-remark-video__b"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "poster": _vm.data.cover,
      "src": _vm.data.link,
      "controls": "controls",
      "preload": "none",
      "playsinline": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.data.content) + "\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a69f1654","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/RemarkDialog.vue
// module id = 6Z/C
// module chunks = 1